module.exports = __webpack_public_path__ + "img/referenti_emt.63f8385e.png";